import(/* webpackMode: "eager" */ "/vercel/path0/app/(front)/maker-space/page.tsx");
